import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { FlexRow } from 'ui-components/components/flex';

import { messages } from './messages';
import style from './fsui-styles.module.less';

/**
 *
 * @param {object} params
 * @param {() => void} params.onClick
 * @param {boolean} params.hasPaymentMethodsToPick
 * @param {boolean} params.isAdding
 * @param {string} [params.className]
 * @param {import('ui-components/components/text').TextTypeValues} [params.labelTextType]
 * @returns {JSX.Element}
 */
export const PickerTitle = ({ onClick, hasPaymentMethodsToPick, isAdding, className, labelTextType = TextType.H2 }) => {
  return (
    <FlexRow className={classnames(style['payment-method-header'], className)}>
      <Text textType={labelTextType} value={messages.paymentMethodLabel} />
      {hasPaymentMethodsToPick && (
        <Button className={style['add-payment-method-link']} onClick={onClick} theme='link'>
          {isAdding ? (
            <FormattedMessage {...messages.selectPaymentMethod} />
          ) : (
            <>
              <span className={style['add-payment-method-icon']}>
                <FontAwesomeIcon icon={faPlus} />
              </span>
              <FormattedMessage {...messages.addPaymentMethod} />
            </>
          )}
        </Button>
      )}
    </FlexRow>
  );
};
